import { render } from "./tab.vue?vue&type=template&id=7e3fb82a&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"

import "./tab.vue?vue&type=style&index=0&id=7e3fb82a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3fb82a"]])

export default __exports__